import { getWorkflowStageKey } from "./getWorkflowStageKey";
import { orderWorkflowStageKeys } from "./orderWorkflowStageKeys";

type WorkflowTemplatePhaseKey = {
  phase: string;
};

export const getWorkflowStageKeys = (
  stageKeys: string[],
  workflowTemplatePhases: WorkflowTemplatePhaseKey[] = []
): string[] => {
  if (!workflowTemplatePhases.length) {
    return stageKeys;
  }

  const orderedPhaseNames = workflowTemplatePhases.map((phaseItem) => getWorkflowStageKey(phaseItem.phase));
  const workflowStageKeys = workflowTemplatePhases
    .map((phaseItem) => getWorkflowStageKey(phaseItem.phase))
    .filter((phaseName) => phaseName.length > 0)
    .reduce<string[]>((result, phaseName) => {
      if (result.includes(phaseName)) {
        return result;
      }

      return [...result, phaseName];
    }, []);
  const unmatchedStageKeys = orderWorkflowStageKeys(stageKeys, orderedPhaseNames).filter(
    (stageKey) => !workflowStageKeys.includes(stageKey)
  );

  return [...workflowStageKeys, ...unmatchedStageKeys];
};
